export class TemplateDateInspection {
    id = 0;
    description = '';
}
